import { render, staticRenderFns } from "./OptionalColorModuleFilters.vue?vue&type=template&id=5d963fc2&scoped=true"
import script from "./OptionalColorModuleFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionalColorModuleFilters.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OptionalColorModuleFilters.vue?vue&type=style&index=0&id=5d963fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d963fc2",
  null
  
)

export default component.exports